module.exports = __webpack_public_path__ + "img/logo1 (3).a4433814.jpg";